// Shared formatting helpers. Currency, 2dp rounding, and ISO date formatting
// were previously copy-pasted across route pages and lib modules; this is the
// single home for them.

const nzdFormatter = new Intl.NumberFormat('en-NZ', {
	style: 'currency',
	currency: 'NZD'
});

/** Format a number as NZD currency (e.g. "-$12.50"). Null/undefined → "$0.00". */
export function formatCurrency(amount: number | null | undefined): string {
	return nzdFormatter.format(amount ?? 0);
}

/** Round to 2 decimal places to avoid floating-point drift. */
export function round2(n: number): number {
	return Math.round(n * 100) / 100;
}

/** Format a Date as YYYY-MM-DD in local time. */
export function formatDate(date: Date): string {
	const yyyy = date.getFullYear();
	const mm = String(date.getMonth() + 1).padStart(2, '0');
	const dd = String(date.getDate()).padStart(2, '0');
	return `${yyyy}-${mm}-${dd}`;
}

/** Parse YYYY-MM-DD as a local calendar date, avoiding UTC offset drift. */
export function parseDateOnly(value: string): Date {
	const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
	if (!match) return new Date(Number.NaN);
	const year = Number(match[1]);
	const month = Number(match[2]);
	const day = Number(match[3]);
	const date = new Date(year, month - 1, day);
	if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
		return new Date(Number.NaN);
	}
	return date;
}
